import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Avatar/avatar';
import { css } from '@patternfly/react-styles';
export var Avatar = function Avatar(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$src = _a.src,
      src = _a$src === void 0 ? '' : _a$src,
      alt = _a.alt,
      props = __rest(_a, ["className", "src", "alt"]);

  return React.createElement("img", Object.assign({}, props, {
    src: src,
    alt: alt,
    className: css(styles.avatar, className)
  }));
};